<template>
    <div id="goodsEdit">
        <steps :active="step - 1" :stepItems="stepItems" />
        <!-- 基础信息 -->
        <div v-if="step == 1">
            <el-card>
                <el-form :model="form" :rules="rules" ref="goods" label-width="120px" label-position="left"
                    size="medium" style="width: 460px;margin: 0 auto;">
                    <el-form-item label="机构名称" prop="organizationId">
                        <el-select v-model="form.organizationId" placeholder="请选择机构名称">
                            <el-option v-for="item in organizations" :key="item.id" :label="item.name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="商品名称" prop="name">
                        <el-input v-model="form.name" placeholder="30字及以内名称" :maxlength="30" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="可用人数" prop="peopleNum">
                        <el-input v-model="form.peopleNum" placeholder="10人及以内"
                            v-input-filter="{ min: 1, max: 10, precision: 0 }" :maxlength="4">
                            <template #append>
                                <span>人</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <!-- 适用地区 -->
                    <el-form-item label="适用地区" prop="area">
                        <el-cascader style="width: 100%;" filterable v-model="form.area" :props="props"
                            :options="cityOptions" placeholder="请选择适用地区" clearable></el-cascader>
                    </el-form-item>
                    <!-- 商品标签 -->
                    <el-form-item label="商品标签" prop="labelIds">
                        <el-checkbox-group v-model="form.labelIds" :max="5">
                            <el-checkbox v-for="item in labelList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
                        </el-checkbox-group>
                        <div class="tips-text" v-if="btnPreFn('travel_label', false)">没有找到想要的标签？前往 <span @click="addLabel">添加标签</span></div>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="medium" type="primary" @click="goStep(2, 'next')">下一步</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div v-if="step == 2">
            <el-card>
                <el-form :model="form" :rules="rules" ref="goodStation" label-width="80px" label-position="left"
                    style="width: 660px; margin: 0 auto;">

                    <div class="formTitle">去程线路</div>
                    <el-table :data="form.goLine" border>
                        <el-table-column label="序号" width="80">
                            <template #default="scope">
                                <span>线路{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="线路名称" prop="value">
                            <template #default="scope">
                                <el-form-item label-width="0" :prop="`goLine.${scope.$index}.value`" :rules="{
                                    required: true,
                                    message: `请选择去程线路${scope.$index + 1}的线路`,
                                    trigger: 'change'
                                }" class="mb-0">
                                    <el-select size="medium" v-model="scope.row.value" placeholder="请选择交通线路" clearable
                                        style="width: 100%;">
                                        <el-option v-for="route in routeOptions" :key="route.value" :label="route.label"
                                            :value="route.value"
                                            :disabled="form.goLine.some(item => item.value === route.value && item !== scope.row)">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template #default="scope">
                                <el-button type="text" class="delete-btn"
                                    @click="removeRoute(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-route mt-16" v-if="form.goLine.length < 6">
                        <a @click="addRoute">+ 添加线路</a>
                    </div>
                    <div class="formTitle" style="margin-top: 32px;">返程线路</div>
                    <el-table :data="form.returnLine" border>
                        <el-table-column label="序号" width="80">
                            <template #default="scope">
                                <span>线路{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="线路名称" prop="value">
                            <template #default="scope">
                                <el-form-item label-width="0" :prop="`returnLine.${scope.$index}.value`" :rules="{
                                    required: true,
                                    message: `请选择返程线路${scope.$index + 1}的线路`,
                                    trigger: 'change'
                                }" class="mb-0">
                                    <el-select size="medium" v-model="scope.row.value" placeholder="请选择交通线路" clearable>
                                        <el-option v-for="route in routeOptions" :key="route.value" :label="route.label"
                                            :value="route.value"
                                            :disabled="form.returnLine.some(item => item.value === route.value && item !== scope.row)">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template #default="scope">
                                <el-button type="text" class="delete-btn"
                                    @click="removeTransfer(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-route mt-16" v-if="form.returnLine.length < 6">
                        <a @click="addTransfer">+ 添加线路</a>
                    </div>
                    <div class="mt-16">
                        <el-button size="medium" @click="goStep(1, 'prev')">上一步</el-button>
                        <el-button size="medium" type="primary" @click="goStep(3, 'next')">下一步</el-button>
                    </div>
                </el-form>
            </el-card>


        </div>
        <div v-if="step == 3">
            <el-card>
                <el-form :model="form" :rules="rules" ref="goodRules" label-width="120px" label-position="left"
                    size="medium" style="width: 460px; margin: 0 auto;">

                    <div class="formTitle">服务策略</div>
                    <!-- 服务车辆类型 -->
                    <el-form-item label="服务车辆类型" prop="serviceVehicleType">
                        <el-radio-group v-model="form.serviceVehicleType">
                            <el-radio v-for="item in $const.SERVICEVEHICLETYPE" :key="item.value" :label="item.value">{{
                                item.label }}</el-radio>
                        </el-radio-group>
                        <div class="tips-text">用户下单时我们会明确告知乘客服务车辆类型，并与乘客签订相应服务协议 <span @click="view">查看示例</span></div>
                    </el-form-item>
                    <!-- 服务模式类型 -->
                    <el-form-item label="服务模式类型" prop="serviceModeType">
                        <el-checkbox-group v-model="form.serviceModeType">
                            <el-checkbox :label="2">
                                拼车
                                <el-tooltip class="item" effect="dark" content="与其他相同行程的乘客拼车出行" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-checkbox>
                            <el-checkbox :label="1">
                                包车
                                <el-tooltip class="item" effect="dark" content="行程由同一个车辆提供接送服务" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <div class="formTitle">商品价格</div>
                    <template v-if="form.serviceModeType.includes(2)">
                        <!-- 单程拼车价格 -->
                        <el-form-item label="单程拼车价格" prop="singlePrice">
                            <el-input v-model="form.singlePrice" placeholder="请输入"
                                v-input-filter="{ min: 1, max: 999999, precision: 2 }">
                                <template #append>元</template>
                            </el-input>
                        </el-form-item>
                        <!-- 往返拼车价格 -->
                        <el-form-item label="往返拼车价格" prop="roundPrice">
                            <el-input v-model="form.roundPrice" placeholder="请输入"
                                v-input-filter="{ min: 1, max: 999999, precision: 2 }">
                                <template #append>元</template>
                            </el-input>
                        </el-form-item>
                    </template>
                    <template v-if="form.serviceModeType.includes(1)">
                        <!-- 单程包车价格 -->
                        <el-form-item label="单程包车价格" prop="singleCharterPrice">
                            <el-input v-model="form.singleCharterPrice" placeholder="请输入"
                                v-input-filter="{ min: 1, max: 999999, precision: 2 }">
                                <template #append>元</template>
                            </el-input>
                        </el-form-item>
                        <!-- 往返包车价格 -->
                        <el-form-item label="往返包车价格" prop="roundCharterPrice">
                            <el-input v-model="form.roundCharterPrice" placeholder="请输入"
                                v-input-filter="{ min: 1, max: 999999, precision: 2 }">
                                <template #append>元</template>
                            </el-input>
                        </el-form-item>
                    </template>


                    <h3 class="formTitle">预约规则</h3>
                    <el-form-item label="最早可预约" prop="advanceReservationTime">
                        <el-input v-model="form.advanceReservationTime"
                            v-input-filter="{ min: 0, max: 7, precision: 0 }" placeholder="请输入">
                            <template #append>
                                <span class="unit-text">天后的行程</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="最晚可预约" prop="reservationTime" required>
                        <div class="flex">
                            <el-input v-model="form.reservationTime" v-input-filter="{ min: 30, max: 90, precision: 0 }"
                                placeholder="请输入">
                                <template #append>
                                    <span class="unit-text">天内的行程</span>
                                </template>
                            </el-input>
                        </div>
                    </el-form-item>

                    <el-form-item>
                        <el-button size="medium" @click="goStep(2, 'prev')">上一步</el-button>
                        <el-button size="medium" type="primary" @click="goStep(4, 'next')">下一步</el-button>
                    </el-form-item>
                </el-form>

            </el-card>
        </div>
        <div v-show="step == 4">
            <el-card>
                <el-form :model="form" :rules="rules" ref="goodsInfo" label-width="80px" label-position="left"
                    size="medium" style="width: 660px; margin: 0 auto;">
                    <h3 class="formTitle">商品主图</h3>
                    <el-form-item label=" " prop="goodsImg" label-width="0">
                        <up-img @remove="removeImg" :files.sync="form.goodsImg" width="80" height="80"
                            :max="5"></up-img>
                    </el-form-item>
                    <div style="font-size: 12px; color: #999;">800*800像素，最多上传5张</div>


                    <h3 class="formTitle">商品描述</h3>
                    <el-form-item label=" " prop="goodsDescribe" label-width="12px">
                        <wangeditor5 :content.sync="form.goodsDescribe" :height="300"></wangeditor5>
                    </el-form-item>

                    
                        <el-button size="medium" @click="goStep(3, 'prev')">上一步</el-button>
                        <el-button size="medium" type="primary" @click="save" :loading="loading">完成</el-button>
                </el-form>
            </el-card>
        </div>

        <LabelDialog :labelVisible.sync="labelVisible" @refresh="refresh" />
    </div>
</template>

<script>
import steps from '../components/steps.vue';
import wangeditor5 from "@/components/wangeditor5.vue";
import { cityCodeJson, getCity } from "@/assets/js/city";
import LabelDialog from '../components/LabelDialog.vue';
import { api as viewerApi } from "v-viewer";

export default {
    name: "goodsEdit",
    components: {
        steps,
        wangeditor5,
        LabelDialog
    },
    data() {
        return {
            id: this.$route.query.id || null,
            loading: false,
            step: 1,
            stepItems: ['1.基础信息', '2.关联线路', '3.商品配置', '4.商品介绍'],
            props: {
                label: "name",
                value: "citycode",
                children: "districts",
            },
            cityOptions: cityCodeJson,
            checkAll: false,
            checkedCities: [],
            form: {
                organizationId: null,
                name: '',
                peopleNum: '',
                area: [],
                labelIds: [],

                goLine: [],
                returnLine: [],

                singlePrice: '',
                roundPrice: '',
                singleCharterPrice: '',
                roundCharterPrice: '',
                serviceVehicleType: '',
                serviceModeType: [],
                reservationTime: 30,
                advanceReservationTime: '',

                goodsImg: '',
                goodsDescribe: '',
            },
            rules: {
                organizationId: [{ required: true, message: '请选择机构名称', trigger: 'change' }],
                name: [{ required: true, message: '请输入商品名称', trigger: ['blur', 'change'] }],
                peopleNum: [{ required: true, message: '请输入可用人数', trigger: ['blur', 'change'] }],
                goodsImg: [{ required: true, message: '请上传商品主图', trigger: 'change' }],
                goodsDescribe: [{ required: true, message: '请输入商品描述', trigger: ['blur', 'change'] }],
                reservationTime: [
                    { required: true, message: '请输入最晚预约时间', trigger: ['blur', 'change'] }
                ],
                advanceReservationTime: [
                    { required: true, message: '请输入最少提前天数', trigger: ['blur', 'change'] }
                ],
                price: [
                    { required: true, message: '请输入商品价格', trigger: ['blur', 'change'] },
                ],
                area: [{ required: true, message: '请选择适用地区', trigger: 'change' }],
                singlePrice: [{ required: true, message: '请输入单程拼车价格' }],
                roundPrice: [{ required: true, message: '请输入往返拼车价格' }],
                singleCharterPrice: [{ required: true, message: '请输入单程包车价格' }],
                roundCharterPrice: [{ required: true, message: '请输入往返包车价格' }],
                serviceVehicleType: [{ required: true, message: '请选择服务车辆类型' }],
                serviceModeType: [{ required: true, message: '请选择服务模式类型' }],
            },
            editor: null,
            routeOptions: [],
            transferOptions: [],
            labelList: [],
            labelVisible: false,
        };
    },
    watch: {
        'form.organizationId': {
            handler(val) {
                if (val) {
                    this.getRouteOptions();
                }
            },
            immediate: true
        },
        'form.serviceModeType': {
            handler(val) {
                if (!val.includes(1)) {
                    this.form.singleCharterPrice = '';
                    this.form.roundCharterPrice = '';
                }
                if (!val.includes(2)) {
                    this.form.singlePrice = '';
                    this.form.roundPrice = '';
                }
            }
        }
    },
    async created() {
        if (this.id) {
            await this.getDetail();
        }
        this.getLabelList();
    },
    async mounted() {
        await this.mixinOrganizations();
        if (!this.id && this.mixinUserInfo?.organizationType === 2 && this.organizations?.[0]?.id) {
            this.$set(this.form, "organizationId", this.organizations[0].id);
        }
    },
    methods: {
        view() {
            let imgs = require("@/assets/img/services.png");
            viewerApi({ images: [imgs] });
        },
        addLabel() {
            this.labelVisible = true;
        },
        refresh(id) {
            this.form.labelIds = this.form.labelIds.filter(item => item !== id);
            this.getLabelList();
        },
        async getLabelList() {
            let url = "/api/v1/manage/travelLabel";
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.labelList = data;
            }
        },
        removeImg(value) {
            console.log('goodsImg', value)
            this.form.goodsImg = value
        },
        goStep(step, type) {
            if (step == 1) {
                this.step = step;
            } else if (step == 2) {
                if (type === 'next') {
                    this.$refs.goods.validate(async (valid) => {
                        if (valid) {
                            let { data, code } = await this.$axios.get("/api/v1/manage/travelGoods/checkGoodsName", {
                                name: this.form.name,
                                id: this.id,
                            });
                            if (code == 1 && data) {
                                this.$message.error("存在相同名称的文旅商品");
                                return;
                            }
                            this.step = step;
                        }
                    });
                } else {
                    this.step = step;
                }
            } else if (step == 3) {
                if (type === 'next') {
                    if (this.form.goLine.length == 0 && this.form.returnLine.length == 0) {
                        this.$message.error('请至少添加一个线路');
                        return;
                    }
                    this.$refs.goodStation.validate((valid) => {
                        if (valid) {
                            this.step = step;
                        } else {
                            this.$message.error('有线路未选择线路，请检查');
                        }
                    });
                } else {
                    this.step = step;
                }
            } else if (step == 4) {
                this.$refs.goodRules.validate((valid) => {
                    if (valid) {
                        this.step = step;
                    }
                });
            }
        },

        // 添加路线
        addRoute() {
            if (this.form.goLine.length >= 6) {
                this.$message.warning('最多只能添加6个线路');
                return;
            }
            this.form.goLine.push({
                value: null,
                label: null
            });
        },

        // 删除路线
        removeRoute(index) {
            if (this.form.goLine[index].value) {
                this.$confirm('是否删除该线路？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.goLine.splice(index, 1);
                });
            } else {
                this.form.goLine.splice(index, 1);
            }
        },

        // 获取线路选项
        async getRouteOptions() {
            let url = '/api/v1/manage/travelLine'
            let params = {
                organizationId: this.form.organizationId
            }
            let { code, data } = await this.$axios.get(url, params);
            if (code === 1) {
                this.routeOptions = data.map(item => ({
                    value: item.id,
                    label: item.startStationName + ' - ' + item.endStationName
                }));
            }
        },

        // 获取商品详情
        async getDetail() {
            if (this.id) {
                let url = `/api/v1/manage/travelGoods/${this.id}`
                let { code, data } = await this.$axios.get(url);
                if (code === 1) {
                    let city = getCity(data.cityCode) || {}
                    this.form = {
                        ...data,
                        goLine: (data.goLineList || []).map(item => ({ value: item.id })),
                        returnLine: (data.returnLineList || []).map(item => ({ value: item.id })),
                        labelIds: data.labelList.map(item => item.labelId),
                        area: [city.provinceCode, city.cityCode],
                        serviceModeType: data.serviceModeType == 3 ? [1, 2] : [data.serviceModeType]
                    };
                }
            }
        },
        save() {
            this.$refs.goodsInfo.validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.id,

                        organizationId: this.form.organizationId,
                        name: this.form.name,
                        peopleNum: this.form.peopleNum,
                        province: getCity(this.form.area[1])?.province,
                        city: getCity(this.form.area[1])?.city,
                        cityCode: getCity(this.form.area[1])?.cityCode,
                        labelIds: this.form.labelIds.join(','),

                        goLine: this.form.goLine.map(item => item.value).join(','),
                        returnLine: this.form.returnLine.map(item => item.value).join(','),

                        serviceVehicleType: this.form.serviceVehicleType,
                        serviceModeType: this.form.serviceModeType.join(',') == '1,2' || this.form.serviceModeType.join(',') == '2,1' ? 3 : this.form.serviceModeType.join(','),
                        singlePrice: this.form.singlePrice,
                        roundPrice: this.form.roundPrice,
                        singleCharterPrice: this.form.singleCharterPrice,
                        roundCharterPrice: this.form.roundCharterPrice,
                        reservationTime: this.form.reservationTime,
                        advanceReservationTime: this.form.advanceReservationTime,

                        goodsImg: this.form.goodsImg,
                        goodsDescribe: this.form.goodsDescribe.replace('" data-href="" style=""/>', ''),
                    }
                    console.log('表单数据:', params);
                    let url = "/api/v1/manage/travelGoods"
                    if (this.id) {
                        this.putFn(url, params)
                    } else {
                        this.postFn(url, params)
                    }
                }
            });
        },
        async postFn(url, params) {
            this.loading = true;
            let { code } = await this.$axios.post(url, params);
            if (code === 1) {
                this.$message.success('保存成功');
                this.$router.go(-1);
            }
            this.loading = false;
        },
        async putFn(url, params) {
            this.loading = true;
            let { code } = await this.$axios.put(url, params);
            if (code === 1) {
                this.$message.success('保存成功');
                this.$router.go(-1);
            }
            this.loading = false;
        },
        // 添加行中接送路线
        addTransfer() {
            if (this.form.returnLine.length >= 6) {
                this.$message.warning('最多只能添加6个线路');
                return;
            }
            this.form.returnLine.push({
                value: null,
                label: null
            });
        },

        // 删除行中接送路线
        removeTransfer(index) {
            if (this.form.returnLine[index].value) {
                this.$confirm('是否删除该线路？', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.returnLine.splice(index, 1);
                });
            } else {
                this.form.returnLine.splice(index, 1);
            }
        },
    }
}
</script>

<style lang="less" scoped>
::v-deep .el-input-group__prepend {
    width: 100px;
    background-color: #fff;
}

::v-deep .el-input-group__append {
    border-left: 1px solid #dcdfe6;
}

#goodsEdit {
    // 卡片样式
    :deep(.el-card) {
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        
        .el-card__body {
            padding: 24px;
        }
    }
    
    // 表单样式
    :deep(.el-form) {
        .el-form-item__label {
            font-weight: 500;
            color: #606266;
        }
        
        .el-input__inner,
        .el-textarea__inner {
            border-radius: 6px;
        }
        
        .el-select {
            width: 100%;
        }
        
        .el-button {
            border-radius: 6px;
        }
    }
    
    // 表单标题
    .formTitle {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 16px;
        padding-left: 10px;
        border-left: 3px solid #2B77FF;
    }

    .tips-text {
        white-space: nowrap;
        font-size: 12px;
        color: #909399;
        margin-top: 8px;

        span {
            color: #2B77FF;
            cursor: pointer;
            
            &:hover {
                text-decoration: underline;
            }
        }
    }

    .mb-0 {
        margin-bottom: 0;
    }

    .mt-16 {
        margin-top: 16px;
    }

    .unit-text {
        white-space: nowrap;
        margin: 0 8px;
        color: #606266;
    }

    .price-tip {
        font-size: 12px;
        color: #909399;
        margin-top: 4px;
    }

    :deep(.el-table) {
        border-radius: 8px;
        
        .el-select {
            width: 100%;
        }
        
        th {
            background: #f5f7fa !important;
            font-weight: 500;
        }
    }

    .delete-btn {
        color: #F56C6C;

        &:hover {
            opacity: 0.8;
        }
    }

    .add-route {
        a {
            color: #2B77FF;
            cursor: pointer;
            font-size: 14px;
            display: inline-flex;
            align-items: center;
            padding: 8px 0;

            &:hover {
                opacity: 0.8;
            }
        }
    }

    :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
        .el-tooltip {
            color: #606266;
        }
    }
    
    // 复选框组样式
    :deep(.el-checkbox-group) {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 16px;
    }
    
    // 单选框组样式
    :deep(.el-radio-group) {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 16px;
    }
}
</style>